import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { OpkraevningSearchParams } from './opkraevning-search-params.model';
import { Opkraevning } from './opkraevning.model';

@Injectable({
  providedIn: 'root',
})
export class OpkraevningDatasource extends TableDatasource<
  Opkraevning,
  OpkraevningSearchParams
> {
  endpoint = '/api/admin/opkraevninger';
  defaultSortField = 'opkraevning.id';
  override defaultDescending = true;
}
